import type { ReleaseDto, ReleaseNotes } from "@hisense/shared";
export interface BrowserBuild {
  id: string;
  version: string;
  mode: "release" | "development" | "untracked";
}
export function updateTarget(
  build: BrowserBuild,
  current: ReleaseDto | null | undefined,
) {
  return build.mode === "release" && current && current.id !== build.id
    ? current
    : null;
}
export function releaseNotes(notes: ReleaseNotes, language: string) {
  if (language === "vi") return notes.vi;
  // Bản phát hành trước khi giao diện đổi sang giản thể chỉ có ghi chú phồn thể.
  if (language.startsWith("zh")) return notes["zh-Hans"] ?? notes["zh-Hant"] ?? notes.en;
  return notes.en;
}
